import type { PortalWorkItemAction } from '../model/myTasks';

export function workItemActionLabel(action: PortalWorkItemAction) {
  if (action.actionCode === 'SAVE') return '保存';
  if (action.actionCode === 'SUBMIT') return '提交';
  return action.label;
}
